import _ from "lodash";
import { Trash2Icon } from "lucide-react";

import {
  SortableDefinitionsType,
  SortableDropdownOpenStateType,
  SortableGroupingItemType,
  SortableType,
} from "@/components/@types";
import { SortChipGroupingSection } from "@/components/organisms/UtilityBar/SortChip/SortChipGroupingSection";
import { SortChipNameSection } from "@/components/organisms/UtilityBar/SortChip/SortChipNameSection";
import { Button } from "@/components/ui/button";

export function SortChipControls({
  sortables,
  sortableDefinitions,
  dropdownOpenIndexes,
  setDropdownOpenIndexes,
  onRemoveSortable,
}: {
  sortables: SortableType[];
  sortableDefinitions: Record<string, SortableDefinitionsType>;
  dropdownOpenIndexes: SortableDropdownOpenStateType[];
  setDropdownOpenIndexes: (value: SortableDropdownOpenStateType[]) => void;
  onRemoveSortable: (index: number) => void;
}) {
  return (
    <div className="flex min-w-0 flex-wrap p-1">
      {sortables.map((sortable, index) => {
        const sortableDefinition = sortableDefinitions?.[sortable.key];
        const ReactIcon = sortableDefinition?.ReactIcon;

        const grouping = _.flatten(sortableDefinition?.operators).find(
          (grouping) => grouping.key === sortable.value,
        ) as SortableGroupingItemType | undefined;
        const ReactGroupingIcon = grouping?.ReactIcon;

        return (
          <div
            key={sortable.key}
            className="min-w-0 flex-row flex gap-1 items-center"
          >
            <SortChipNameSection
              index={index}
              sortables={sortables}
              ReactIcon={ReactIcon}
              sortableDefinition={sortableDefinition}
              dropdownOpenIndexes={dropdownOpenIndexes}
              setDropdownOpenIndexes={setDropdownOpenIndexes}
            />
            <SortChipGroupingSection
              index={index}
              sortable={sortable}
              sortables={sortables}
              ReactGroupingIcon={ReactGroupingIcon}
              grouping={grouping}
              sortableDefinition={sortableDefinition}
              dropdownOpenIndexes={dropdownOpenIndexes}
              setDropdownOpenIndexes={setDropdownOpenIndexes}
            />
            <Button
              variant="secondary"
              size="icon-xs"
              data-testid={`sort-chip-delete-${sortableDefinition?.name}`}
              onClick={() => onRemoveSortable(index)}
              className="text-destructive hover:text-destructive"
            >
              <Trash2Icon />
            </Button>
          </div>
        );
      })}
    </div>
  );
}
